import React from 'react'

const About = () => {
  return (
    <div style={{marginTop:'10vh'}}>About</div>
  )
}

export default About